import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { QrCode, X, Copy } from "lucide-react";

/* QR Code para os consultores marcarem presença à entrada da reunião. */
export default function CheckinQrButton({ conv }) {
  const [url, setUrl] = useState(null);

  const open = async () => {
    try {
      const r = await api.post(`/convocations/${conv.id}/checkin-qr`);
      setUrl(`${window.location.origin}${r.data.path}`);
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <>
      <button onClick={open} className="kw-btn-secondary !py-2 text-[10px] inline-flex items-center gap-1.5"
        data-testid={`convocation-checkin-qr-${conv.id}`}>
        <QrCode className="w-3 h-3" /> QR de presenças
      </button>
      {url && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setUrl(null)}>
          <div className="bg-white text-black p-8 max-w-md w-full text-center relative" onClick={(e) => e.stopPropagation()}
            data-testid="checkin-qr-modal">
            <button onClick={() => setUrl(null)} className="absolute top-3 right-3 text-[#555] hover:text-black"
              data-testid="checkin-qr-close"><X className="w-5 h-5" /></button>
            <div className="text-[11px] tracking-[0.3em] font-bold text-[#E50000]">MARCA A TUA PRESENÇA</div>
            <div className="font-display text-2xl font-black uppercase mt-1 mb-5">{conv.title}</div>
            <div className="flex justify-center"><QRCodeCanvas value={url} size={300} level="M" includeMargin /></div>
            <p className="text-xs text-[#555] mt-4">Aponta a câmara do telemóvel. Abre 30 min antes e fecha no fim da reunião.</p>
            <button onClick={() => { navigator.clipboard.writeText(url); toast.success("Link copiado"); }}
              className="mt-4 text-[10px] uppercase tracking-widest font-bold px-3 py-2 border border-[#ccc] inline-flex items-center gap-1.5"
              data-testid="checkin-qr-copy">
              <Copy className="w-3 h-3" /> Copiar link
            </button>
          </div>
        </div>
      )}
    </>
  );
}
